/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./drawerItem.vue?vue&type=template&id=4acf4682"
import script from "./drawerItem.vue?vue&type=script&lang=js"
export * from "./drawerItem.vue?vue&type=script&lang=js"
import style0 from "./drawerItem.vue?vue&type=style&index=0&id=4acf4682&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports